import React, { useEffect, useRef, useLayoutEffect } from "react";
import styled from "styled-components";
import ProgressIndicator from "../ProgressIndicator/ProgressIndicator";

const Sentinel = styled.div`
  height: 1px;
`;

const SpinnerRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px;
`;

interface InfiniteScrollSentinelProps {
  onEndReached: () => void;
  isFetchingMore?: boolean;
}

export function InfiniteScrollSentinel({
  onEndReached,
  isFetchingMore,
}: InfiniteScrollSentinelProps): React.ReactElement {
  const ref = useRef<HTMLDivElement | null>(null);
  const callbackRef = useRef(onEndReached);
  useLayoutEffect(() => {
    callbackRef.current = onEndReached;
  }, [onEndReached]);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) callbackRef.current();
      },
      { rootMargin: "200px" },
    );
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <Sentinel ref={ref} />
      {isFetchingMore && (
        <SpinnerRow>
          <ProgressIndicator />
        </SpinnerRow>
      )}
    </>
  );
}
